/**
 * @generated SignedSource<<6c8d6f6aa422376f93280e7dc53c61ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSubmissionDialog_GetProjectsQuery$variables = {
  perPage?: number | null | undefined;
  screening: boolean;
};
export type ProjectSubmissionDialog_GetProjectsQuery$data = {
  readonly projects: {
    readonly nodes: ReadonlyArray<{
      readonly custom: boolean | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly title: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"CodeSubmissionDialog_Project" | "useCodeTestBrowserForm_Project">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ProjectSubmissionDialog_GetProjectsQuery = {
  response: ProjectSubmissionDialog_GetProjectsQuery$data;
  variables: ProjectSubmissionDialog_GetProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screening"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "perPage"
  },
  {
    "kind": "Variable",
    "name": "screening",
    "variableName": "screening"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "custom",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSubmissionDialog_GetProjectsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projects",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CodeSubmissionDialog_Project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useCodeTestBrowserForm_Project"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectSubmissionDialog_GetProjectsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projects",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectSubmission",
                "kind": "LinkedField",
                "name": "submission",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "666286b3baf9f933667dd6d76e1788ee",
    "id": null,
    "metadata": {},
    "name": "ProjectSubmissionDialog_GetProjectsQuery",
    "operationKind": "query",
    "text": "query ProjectSubmissionDialog_GetProjectsQuery(\n  $screening: Boolean!\n  $perPage: Int\n) {\n  projects(screening: $screening, first: $perPage) {\n    nodes {\n      id\n      title\n      description\n      custom\n      ...CodeSubmissionDialog_Project\n      ...useCodeTestBrowserForm_Project\n    }\n  }\n}\n\nfragment CodeSubmissionDialog_Project on Project {\n  id\n  title\n  submission {\n    description\n    url\n    id\n  }\n  ...useCodeTestBrowserForm_Project\n}\n\nfragment useCodeTestBrowserForm_Project on Project {\n  id\n  title\n  status\n}\n"
  }
};
})();

(node as any).hash = "9f34b00ba838ce8616ff748a9486b10a";

export default node;
